module.exports = __webpack_public_path__ + "img/hvad-har-du-lavet-5.769539f2.png";